import { Landmark } from 'lucide-react';
import { formatRange } from './utils';
import { formatMinor, TaxLineRow, TaxReportCard, TaxStatCell, TaxStatStrip } from './taxReportShared';

interface Data {
  type: string;
  periodStart: string;
  periodEnd: string;
  turnoverMinor: number;
  profitBeforeTaxMinor: number;
  allowableExpensesMinor: number;
  taxableProfileMinor: number;
  corporationTaxMinor: number;
  corporationTaxRateBps: number;
  disclaimer?: string;
}

export function TaxCt600Report({ data }: { data: Record<string, unknown> }) {
  const d = data as unknown as Data;

  return (
    <TaxReportCard
      icon={Landmark}
      title="CT600 — Corporation Tax"
      badge={formatRange(d.periodStart, d.periodEnd)}
    >
      <TaxStatStrip>
        <TaxStatCell label="Profit before tax" value={formatMinor(d.profitBeforeTaxMinor, 'GBP')} />
        <TaxStatCell
          label={`Corp tax @ ${(d.corporationTaxRateBps / 100).toFixed(0)}%`}
          value={formatMinor(d.corporationTaxMinor, 'GBP')}
          emphasis
        />
      </TaxStatStrip>

      <table className="w-full text-sm">
        <thead>
          <tr className="bg-surface-50/60 text-[11px] uppercase tracking-[0.06em] text-surface-500">
            <th className="px-4.5 py-2 text-left font-medium">Line</th>
            <th className="px-4.5 py-2 text-right font-medium">Amount</th>
          </tr>
        </thead>
        <tbody>
          <TaxLineRow label="Turnover" value={formatMinor(d.turnoverMinor, 'GBP')} />
          <TaxLineRow
            label="Allowable expenses"
            value={formatMinor(d.allowableExpensesMinor, 'GBP')}
          />
          <TaxLineRow
            label="Profit before tax"
            value={formatMinor(d.profitBeforeTaxMinor, 'GBP')}
            strong
          />
          <TaxLineRow label="Taxable profit" value={formatMinor(d.taxableProfileMinor, 'GBP')} />
          <TaxLineRow
            label="Corporation tax due"
            value={formatMinor(d.corporationTaxMinor, 'GBP')}
            strong
          />
        </tbody>
      </table>

      {d.disclaimer ? (
        <div className="border-t border-surface-100 px-4.5 py-2.5 text-[11px] italic text-surface-400">
          {d.disclaimer}
        </div>
      ) : null}
    </TaxReportCard>
  );
}
